import React from 'react'
import PageHeader from '../../../components/admin/PageHeader/PageHeader'
import styles from "./all-chats.module.scss"
import { chatsData } from '../../../assets/data/chatsData'
import GenericTable from '../../../components/common/Table/GenericTable'
function AllChats() {
    return (
        <div className={styles.root}>
            <div className={styles.header_container}>

                <PageHeader title="All Chats" subTitle={'View your chats, add a user to a chat, and creat a chat.'} />
            </div>
            <div>
                <GenericTable
                    columns={['Name chat', 'User', '']}
                    rows={chatsData}
                    forChats={true}
                />
            </div>


        </div>
    )
}

export default AllChats